import { ParsedQuery } from 'query-string';

import { urlBuilder } from './urlBuilder';

export const addAccountUrl = (params?: ParsedQuery<string | number | boolean>, absolute: boolean = true) => {
  const productCategory = params?.product_category;
  let url;
  if (productCategory === 'solo_401k') {
    url = urlBuilder.appSolo401kInterest;
  } else if (productCategory === 'direct_trading') {
    url = urlBuilder.appAddAccount;
  } else {
    url = urlBuilder.appAddGoalFlowsNew;
  }

  return absolute ? url.absolute(params) : url(params);
};
